import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

export const getUsers = state => (state.users);
export const getFeatures = state => (state.features)

/***************************** Subroutines ************************************/

function * initFeaturesTree() {
	// Used to test if one feature is a parent of another
	let equalArrays = (a, b) => {
		if(a.length !== b.length)
			return false;
		for(let i = 0; i < a.length; i++) {
			if(a[i] !== b[i])
				return false
		}
		return true;
	}

	try {
		yield put(Actions.toggleFetchingFeatures(true))

		let features = yield select(getFeatures)
		let users = yield select(getUsers);
		let user, features_list;

		if(users.user.is_admin && users.proxy_account != null)
			user = users.proxy_account;
		else
			user = users.user;

		features_list = user.features.filter(f => !/^\/Plans\/(State|City|National)/.test(f.path));

		// *** Check for orphan features *** //
		let needed_parents = [];
		yield features_list.forEach(feature => {
			let path_array = feature.path.split('/').filter(e => e !== '')
			path_array.pop()

			while(path_array.length >= 1) {
				let parent_path = `/${path_array.join('/')}/`
				if(!features_list.find(f => f.path === parent_path)) {
					if(!needed_parents.find(f => f === parent_path))
	  				needed_parents.push(parent_path)
				}
				path_array.pop()
			}
		})

		if(needed_parents.length > 0) {
			let missing_features = yield call(Api.getFeaturesByPath, needed_parents)
			features_list = [...features_list, ...missing_features]
			needed_parents = []
		}
		// *** Finished checking for orphan features *** //
		yield put(Actions.updateFeaturesList(features_list))
		yield put(Actions.updateFeaturesTree(features_list.map(f => ({feature : f, children : []}))))

		features = yield select(getFeatures)

		// *** Build tree *** //
		for(let i = 0; i < features.features_tree.length ; i++) {
			let current_feature = features.features_tree[i].feature;
			let feature_path_array = current_feature.path.split('/').filter(e => e !== '')

			if(feature_path_array.length > 1) {
				let parent_feature = features.features_tree.find(parent_feature_node => {
					let parent_feature_path_array = parent_feature_node.feature.path.split('/').filter(e => e !== '')
					return equalArrays(parent_feature_path_array, feature_path_array.slice(0, feature_path_array.length - 1))
				})
				if(parent_feature) {
					let temp_tree = [...features.features_tree]
					let parent_index = temp_tree.findIndex(f => f.feature._id === parent_feature.feature._id)
					let child_index = temp_tree.findIndex(f => f.feature._id === current_feature._id)
					if(parent_index === -1 || child_index === -1)
						console.log('Error creating features tree')

					temp_tree[parent_index].children.push(temp_tree[child_index])
					yield put(Actions.updateFeaturesTree(temp_tree))
					features = yield select(getFeatures)
				}
				else {
					throw new Error('Missing parent in features tree')
				}
			}
		}
		yield put(Actions.toggleFetchingFeatures(false))
	}
	catch(ex) {
		console.log(ex)
		yield put(Actions.toggleFetchingFeatures(false))
	}
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* featuresWatcher() {
  yield* [
  	takeEvery(ActionTypes.BEGIN_INIT_FEATURES_TREE, initFeaturesTree),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/features.js